import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";

const CategoryPopup = ({ isOpen, onClose, onCategorySuccess }) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    try {
      const response = await apiService.get("/expense_categories");
      setCategories(response.data || []);
    } catch (errors) {
      handleError(errors);
    }
  };

  if (!isOpen) return null;

  const validationSchema = Yup.object({
    category: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only letters and spaces allowed")
      .required("Category name is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const existingNames = categories.map((item) =>
      item.name.toLowerCase().trim()
    );
    const newName = values.category.trim().toLowerCase();

    if (existingNames.includes(newName)) {
      toast.error("This category name already exists!",{duration:1000});
      return;
    }

    setLoading(true);
    try {
      const payload = {
        name: values.category,
      };

      const response = await apiService.post("/expense_categories", payload);

      toast.success(response?.data?.message || "Category added successfully!", {
        duration: 2000,
      });
      resetForm();
      onClose();
      if (onCategorySuccess) onCategorySuccess();
    } catch (errors) {
      handleError(errors);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-[310px] relative">
        <h3 className="text-xl font-semibold mb-7 text-G500 text-start">
          Add Category
        </h3>
        <div
          className="absolute top-5 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
          onClick={onClose}
        >
          <icons.IoClose className="text-green700 text-xl" />
        </div>

        <Formik
          initialValues={{ category: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <div className="relative text-G300">
                <label className="text-sm font-medium text-G500 mb-2 block">Category Name <span className="text-red ">*</span></label>
                <Field
                  type="text"
                  name="category"
                  autoComplete="new-category"
                  className="inputtext relative"
                  placeholder="Enter category"
                />
                <ErrorMessage
                  name="category"
                  component="div"
                  className="text-red text-sm mt-1"
                />
              </div>

              <div className="flex justify-end space-x-4 pt-8">
                <button
                  type="button"
                  className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg bg-green text-white"
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CategoryPopup;
